import React, {Component, Fragment} from "react";
import ReactDOM from "react-dom";
import {Link} from "react-router-dom";

const options = {threshold: 0.1};

class MainPixelogChallengesCard extends Component {

    constructor(props) {
        super(props);

        this.imgRef = React.createRef();
    }

    componentDidMount() {
        const observer = new IntersectionObserver(this.callback, options);
        observer.observe(this.imgRef.current);
    }

    callback = (entries, observer) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                observer.unobserve(entry.target);
                entry.target.src = entry.target.dataset.src;
            }
        });
    };

    render() {

        const {dataKey, created_at, cnt, ctags, tags, type, challenge_created_at, name,nick,uid} = this.props;

        var year = created_at.substring(2, 4);
        var month = created_at.substring(5, 7);
        var day = created_at.substring(8, 10);

        // ai 이미지경로
        if (type == '1') {
            var imgSrc = `/outputs/txt2img/20${year}-${month}-${day}/${dataKey}.png`;
        } else {
            var imgSrc = `/upload/${year}/${month}/${day}/${dataKey}.png`;
        }

        return (
            <Link
                style={{"color": "black"}}
                to={{
                    pathname: `/search/tag=${ctags}`
                }}
            >

                <div className="grid-item card-preview-container card-challenge-img-container shadow">
                    <div className="d-grid challenge-container">
                        <div className="neo neo-contents-tags text-truncate text-left card-challenge card-challenge-date">{challenge_created_at.substring(0, 10)}</div>
                        <div className="neo neo-contents-tags text-truncate text-center card-challenge card-challenge-title">{ctags}</div>
                        <div className="neo neo-contents-tags text-truncate text-right card-challenge"></div>
                    </div>
                    <img
                        className="card-challenge-img"
                        style={{
                            width: "100%",
                            height: "auto",
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                        }}
                        //style={{width: "100%", borderRadius: "16px"}}
                        // src='/img/pixelog-gif.gif'
                        src='/img/pixelog-loading-gradation-bg.gif'
                        data-src={imgSrc}
                        ref={this.imgRef}
                        alt={ctags}
                    />

                    <div className="card-preview-actions-tags">
                        <div className="card-preview-contents-tags text-white text-left">
                            <div className="neo neo-contents-tags"
                                 style={{
                                     position: "absolute",
                                     bottom: "-8px",
                                     right: "10px",
                                }}
                            >By {nick}</div>
                        </div>
                    </div>
                </div>
            </Link>
        ); //return
    }
}

export default MainPixelogChallengesCard;